<template>
  <div class="role position-relative">
    <img src="../../assets/img/role/title.png" alt="" srcset="" class="title" />

    <!-- 实际展示区域 -->
    <div
      class="box ani"
      swiper-animate-effect="fadeInUp"
      swiper-animate-duration="0.3s"
      swiper-animate-delay="0.1s"
    >
      <swiper :options="silderOption" ref="silderSwiper">
        <swiper-slide v-for="(n, index) in list" :key="index" class="b-slide">
          <div class=" position-relative roleInfo">
            <img :src="n.roleInfo" alt="" srcset="" />
          </div>
        </swiper-slide>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
        <div
          class="
            swiper-pagination swiper-pagination-role
            cursor
            position-absolute
          "
          slot="pagination"
        ></div>
      </swiper>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      silderOption: {
        //    autoplay: {
        //      disableOnInteraction: false,
        //      delay: 10000
        //    },
     //    loop: true,
        direction: "horizontal",
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper

        pagination: {
          el: ".swiper-pagination-role",
          touchRatio: 1, //解决滑动卡顿
          longSwipesRatio: 0.1,
          threshold: 10, //如果触摸距离小于该值滑块不会被拖动
          followFinger: false,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          clickable: true, // 允许点击小圆点跳转
          renderBullet: function(index, className) {
            switch (index) {
              case 0:
                name = "";
                break;
              case 1:
                name = "";
                break;
              case 2:
                name = "";
              case 3:
                name = "";
              default:
                name = "";
            }
            return (
              '<div class="' +
              className +
              " " +
              className +
              [index] +
              '"><i>' +
              name +
              "</i></div>"
            );
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      list: [
        {
          id: 1,
          roleInfo: require("../../assets/img/role/character_1/roleInfo.png")
        },

        {
          id: 2,
          roleInfo: require("../../assets/img/role/character_2/roleInfo.png")
        },
        {
          id: 3,
          roleInfo: require("../../assets/img/role/character_3/roleInfo.png")
        },
        {
          id: 4,
          roleInfo: require("../../assets/img/role/character_4/roleInfo.png")
        },
        {
          id: 5,
          roleInfo: require("../../assets/img/role/character_5/roleInfo.png")
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.role {
  height: 1080px;
  width: 100%;

  background-image: url("../../assets/img/role/bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  .title {
    width: 781px;
    height: auto;
    padding-top: 6vw;
    display: block;
    margin: 0 auto;
  }

  .box {
    position: absolute;
    z-index: 0;
    width: 1300px;
    left: 50%;
    transform: translate(-50%, 0);
        padding-top: 2vw;

    .roleInfo {
      img {
        display: block;
        width: 1215px;
        height: auto;
        //    height: 774px;
        margin: 0 auto;
      }
    }
    .b-slide {
    }
  }

    .swiper-button-prev:after {
      display: none;
    }

    .swiper-button-next:after {
      display: none;
    }

    .swiper-button-prev {
      background: url("../../assets/img/role/prev.png") no-repeat top;
      background-size: 100% 100%;
      width: 37px;
      height: 48px;
      top: 26vw;
      left:0;
      z-index: 3;

    }

    .swiper-button-next {
      background: url("../../assets/img/role/next.png") no-repeat top;
      background-size: 100% 100%;
      width: 37px;
      height: 48px;
      top: 26vw;
      left: 32vw;
     // right: 0;
      z-index: 3;
    }
 
  // 角色轮播图分页圆点更改背景
  .swiper-pagination-role {
    left: 3vw !important;
    width: 540px !important;
    height: 131px;
    top: 23vw;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.2vw;
    .swiper-pagination-bullet-active {
      background: transparent;
      i {
        width: 109px !important;
        height: 109px !important;
      }
    }

    .my-bullet {
      i {
        display: block;
        width: 99px;
        height: 99px;
      }
    }

    // 未选中
    .my-bullet0 {
      i {
        background: url("../../assets/img/role/btn1.png") center top;
        background-size: 100% 100%;
      }
    }

    .my-bullet1 {
      i {
        background: url("../../assets/img/role/btn2.png") center top;
        background-size: 100% 100%;
      }
    }

    .my-bullet2 {
      i {
        background: url("../../assets/img/role/btn3.png") center top;
        background-size: 100% 100%;
      }
    }
    .my-bullet3 {
      i {
        background: url("../../assets/img/role/btn4.png") center top;
        background-size: 100% 100%;
      }
    }
    .my-bullet4 {
      i {
        background: url("../../assets/img/role/btn5.png") center top;
        background-size: 100% 100%;
      }
    }

    //     // 选中后的按钮图
    .my-bullet0.swiper-pagination-bullet-active i {
      background: url("../../assets/img/role/btn1-active.png") center top;
      background-size: 100% 100%;
    }

    .my-bullet1.swiper-pagination-bullet-active i {
      background: url("../../assets/img/role/btn2-active.png") center top;
      background-size: 100% 100%;
    }

    .my-bullet2.swiper-pagination-bullet-active i {
      background: url("../../assets/img/role/btn3-active.png") center top;
      background-size: 100% 100%;
    }

    .my-bullet3.swiper-pagination-bullet-active i {
      background: url("../../assets/img/role/btn4-active.png") center top;
      background-size: 100% 100%;
    }
    .my-bullet4.swiper-pagination-bullet-active i {
      background: url("../../assets/img/role/btn5-active.png") center top;
      background-size: 100% 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mainComponents/rolePage.vue